export default __webpack_public_path__ + "static/media/watch2.6b8171fa.jpg";